/* ============================================================
   OI CURSOR + NAV — Custom cursor and nav scroll behavior
   ============================================================ */

(function () {
  'use strict';

  const isTouch = window.matchMedia('(hover: none)').matches;

  if (!isTouch) {
    const cursorEl = document.createElement('div');
    cursorEl.id = 'oi-cursor';
    cursorEl.innerHTML = '<div id="oi-cursor-dot"></div><div id="oi-cursor-ring"></div>';
    document.body.appendChild(cursorEl);

    const dot  = document.getElementById('oi-cursor-dot');
    const ring = document.getElementById('oi-cursor-ring');

    let mx = -100, my = -100, rx = -100, ry = -100;

    document.addEventListener('mousemove', e => {
      mx = e.clientX; my = e.clientY;
      dot.style.left = mx + 'px';
      dot.style.top  = my + 'px';
    });

    function animateRing() {
      rx += (mx - rx) * 0.13;
      ry += (my - ry) * 0.13;
      ring.style.left = rx + 'px';
      ring.style.top  = ry + 'px';
      requestAnimationFrame(animateRing);
    }
    animateRing();

    document.addEventListener('mouseover', e => {
      if (e.target.closest('a, button, [role="button"], .oi-mosaic__cell, .oi-pillar')) {
        document.body.classList.add('oi-hovering');
      }
    });
    document.addEventListener('mouseout', e => {
      if (e.target.closest('a, button, [role="button"], .oi-mosaic__cell, .oi-pillar')) {
        document.body.classList.remove('oi-hovering');
      }
    });
  }

  const header = document.querySelector('.header');
  if (header) {
    function updateNav() {
      if (window.scrollY > 60) {
        header.classList.add('oi-scrolled');
      } else {
        header.classList.remove('oi-scrolled');
      }
    }
    window.addEventListener('scroll', updateNav, { passive: true });
    updateNav();
  }

  const headerHeading = document.querySelector('.header__heading a, .header__heading-logo-wrapper a');
  if (headerHeading) {
    headerHeading.classList.add('oi-nav-logo');
    const mark = document.createElement('span');
    mark.className = 'oi-nav-logo-mark';
    headerHeading.prepend(mark);
  }

  const reveals = document.querySelectorAll('.oi-reveal');
  if (reveals.length && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('oi-visible');
        }
      });
    }, { threshold: 0.12 });
    reveals.forEach(el => io.observe(el));
  }

})();
